import { API_BASE_URL } from "@config";
import { useEffect, useState } from "react";
import { Popup } from "@/components/common/Popup";
import { SiteInfoSchema } from "@/components/site/SiteSchema";


// Component
export function SitePage() {
  const [sites, setSites] = useState<SiteInfoSchema[]>([]);
  const [editSiteId, setEditSite] = useState<number | null>(null);


   useEffect(() => {
        fetch(`${API_BASE_URL}/App/GetSites`) // replace with your API endpoint
          .then(res => {
            if (!res.ok) throw new Error("Failed to fetch");
            return res.json();
          })
          .then(data => {
            setSites(data);
           // setLoading(false);
          })
          .catch(err => {
            console.error(err);
            //setLoading(false);
          });
      }, []);
      
  return (
    <div className="h-[calc(100vh-60px)] flex flex-col">
      <div className="content-header flex justify-between border-b border-gray-300 pt-[0.6rem] pb-[0.6rem] px-8 bg-gray-50">
        <div className="flex items-center gap-4">
          <h1 className="font-bold text-2xl">Sites</h1>
        </div>

      </div>

      
        <div className="flex-1 overflow-auto">
          <table className="table-auto w-full border-collapse">
            <thead className="border-b border-gray-300  text-sm text-gray-600">
              <tr>
                <th className="px-4 py-2 text-left">Name</th>
                <th className="px-4 py-2 text-left">Occupancy</th>
                <th className="px-4 py-2 text-left">Rerun 1</th>
                <th className="px-4 py-2 text-left">Rerun 2</th>
                <th className="px-4 py-2 text-left">Rerun 3</th>
                <th className="px-4 py-2 text-left">Loop Duration</th>
              </tr>
            </thead>
            <tbody>
            {sites.map((item) => (
              <tr
                key={item.id}
                className="border-t hover:bg-gray-100 cursor-pointer"
                onClick={() => setEditSite(item.id as number)}
              >
               
                <td className="px-4 py-2">{item.name}</td>
                <td className="px-4 py-2">{item.occupancy}</td>
                <td className="px-4 py-2">{item.rerun1}</td>
                <td className="px-4 py-2">{item.rerun2}</td>
                <td className="px-4 py-2">{item.rerun3}</td>
                <td className="px-4 py-2">{item.duration}</td>
              </tr>
            ))}
          </tbody>
          </table>
        </div>
     
     

    

      {/* <Popup
        isOpen={editSiteId !== null}
        onClose={() => setEditSite(null)}
        title="Site Info"
        boxwidth="800px"
      >
        <SiteInfo onClose={() => setEditSite(null)} siteId={editSiteId ?? -1} />
      </Popup> */}
    </div>
  );
}
